<template>
  <div id="myChart" :style="{ height: '100%' }" class="charts-pie"></div>
</template>

<script>
import ECharts from "echarts/lib/echarts";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
export default {
  name: "charts-pie",
  data() {
    return {
      charts: null,
    };
  },
  props: {
    options: [Object],
    loading: { type: Boolean, default: true },
    FullNamedata: {
      type: Array,
      //   default:
    },
  },
  watch: {},
  created() {},
  mounted() {
    let _this = this;
    setTimeout(() => {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表

      let option = {
        title: { text: "15天销量走势图" },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
            lineStyle: {
              color: "#57617B",
            },
          },
        },
       /*  grid: {
          top: "36px",
          left: "36px",
          right: "36px",
          bottom: "50px",
        }, */
        // legend: {
        //   data: ["销量"],
        // },
        xAxis: {
          type: "category",
        },
        yAxis: {},
        axisPointer: {
          snap: true,
          lineStyle: {
            color: "#7581BD",
            width: 2,
          },
        },
        series: [
          {
            name: "销量",
            type: "line",
            smooth: true,
            // symbol: "circle", // 拐点类型
            symbolSize: 3, // 拐点圆的大小
            itemStyle: {
              normal: {
                color: "#8884BA", // 折线条的颜色
                borderColor: "#8884BA", // 拐点边框颜色
                areaStyle: {
                  type: "default",
                  opacity: 0.3,
                }, // 渐变
              },
            },
            data: _this.FullNamedata,
            // data: [
            //   ["Mon", 1],
            //   ["Tue", 2],
            //   ["Wed", 5],
            //   ["Thu", 10],
            // ],
          },
          /*   {
            name: "金额",
            type: "line",
            smooth: true,
            // symbol: "circle", // 拐点类型
            symbolSize: 3, // 拐点圆的大小
            itemStyle: {
              normal: {
                color: "#dd9966", // 折线条的颜色
                borderColor: "#dd9966", // 拐点边框颜色
                areaStyle: {
                  type: "default",
                  opacity: 0.1,
                }, // 渐变
              },
            },
            // data: _this.FullNamedata,
            data: [
              ["Mon", 1000],
              ["Tue", 500],
              ["Wed", 700],
              ["Thu", 1520],
            ],
          }, */
        ],
      };
      myChart.setOption(option);
      // 动态显示tootip  暂时关闭
      // var faultByHourIndex = 0; //播放所在下标
      // setInterval(function () {
      //   //使得tootip每隔三秒自动显示
      //   myChart.dispatchAction({
      //     type: "showTip", // 根据 tooltip 的配置项显示提示框。
      //     seriesIndex: 0,
      //     dataIndex: faultByHourIndex,
      //   });
      //   faultByHourIndex++;
      //   // option.series[0].data.length 是已报名纵坐标数据的长度
      //   if (faultByHourIndex > option.series[0].data.length) {
      //     faultByHourIndex = 0;
      //   }
      //   if (faultByHourIndex > option.series[1].data.length) {
      //     faultByHourIndex = 0;
      //   }
      //   if (faultByHourIndex > option.series[2].data.length) {
      //     faultByHourIndex = 0;
      //   }
      // }, 3000);
    }, 1000);
  },
};
</script>

<style scoped>
.charts-pie {
  width: calc(100% - 14px);
  padding: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Common/echarts/echartsline.vue